/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useEffect, useRef, useState } from "react";
import panzoom from "panzoom";
import "./ZoomImage.scss";

function ZoomImage({ src, alt = "Preview Image", onLoad, ...restProps }: any) {
  // State
  // @ts-expect-error TS(6133): 'hasLoaded' is declared but its value is never rea... Remove this comment to see the full error message
  const [hasLoaded, setHasLoaded] = useState(false);
  const [minScale] = useState(1);
  // @ts-expect-error TS(6133): 'maxScale' is declared but its value is never read... Remove this comment to see the full error message
  const [maxScale, setMaxScale] = useState(3);

  // Refs
  const imgRef = useRef(null);
  const pzInstanceRef = useRef(null);

  // Image style
  const imgStyle = {
    touchAction: "none",
    transformOrigin: "0 0"
  };

  // Calculate max zoom
  function calculateMaxZoom() {
    if (!imgRef.current) return 3;
    const $img = imgRef.current;
    // @ts-expect-error TS(2339): Property 'parentElement' does not exist on type 'n... Remove this comment to see the full error message
    const container = $img.parentElement;
    if (!container) return 3;

    const containerRect = container.getBoundingClientRect();
    if (containerRect.width === 0 || containerRect.height === 0) return 3;

    const { naturalWidth } = $img;
    const { naturalHeight } = $img;
    if (naturalWidth === 0 || naturalHeight === 0) return 3;

    const zoomX = naturalWidth / 3 / containerRect.width;
    const zoomY = naturalHeight / 3 / containerRect.height;
    const calculatedZoom = Math.max(zoomX, zoomY, 1);

    return calculatedZoom;
  }

  // Image load handler
  function handleLoad() {
    setHasLoaded(true);
    const newMaxScale = calculateMaxZoom();
    setMaxScale(newMaxScale);

    if (pzInstanceRef.current) {
      try {
        // @ts-expect-error TS(2339): Property 'dispose' does not exist on type 'never'.
        pzInstanceRef.current.dispose();
      } catch {
        // eslint-disable-next-line no-console
        console.error("Error disposing panzoom for zoom update");
      }

      try {
        // @ts-expect-error TS(2322): Type 'PanZoom' is not assignable to type 'null'.
        pzInstanceRef.current = panzoom(imgRef.current, {
          maxZoom: newMaxScale,
          minZoom: minScale,
          bounds: true,
          boundsPadding: 0
        });
      } catch {
        // eslint-disable-next-line no-console
        console.error("Error reinitializing panzoom with updated zoom");
      }
    }

    onLoad?.();
  }

  // Lifecycle
  useEffect(() => {
    const $img = imgRef.current;
    if (!$img) return;

    try {
      const initializePanzoom = () => {
        // @ts-expect-error TS(2339): Property 'complete' does not exist on type 'never'... Remove this comment to see the full error message
        if ($img.complete && $img.naturalHeight !== 0) {
          const maxZoom = calculateMaxZoom();
          setMaxScale(maxZoom);
          // @ts-expect-error TS(2322): Type 'PanZoom' is not assignable to type 'null'.
          pzInstanceRef.current = panzoom($img, {
            maxZoom,
            minZoom: minScale,
            bounds: true,
            boundsPadding: 0
          });
        } else {
          // @ts-expect-error TS(2322): Type 'PanZoom' is not assignable to type 'null'.
          pzInstanceRef.current = panzoom($img, {
            maxZoom: 3,
            minZoom: minScale,
            bounds: true,
            boundsPadding: 0
          });
        }
      };

      initializePanzoom();
    } catch {
      // eslint-disable-next-line no-console
      console.error("Error initializing panzoom");
    }

    // Cleanup
    // eslint-disable-next-line consistent-return
    return () => {
      try {
        // @ts-expect-error TS(2339): Property 'dispose' does not exist on type 'never'.
        if (pzInstanceRef.current && typeof pzInstanceRef.current.dispose === "function") {
          // @ts-expect-error TS(2339): Property 'dispose' does not exist on type 'never'.
          pzInstanceRef.current.dispose();
        }
      } catch {
        // eslint-disable-next-line no-console
        console.error("Error disposing panzoom");
      }
    };
  }, [minScale]);

  return (
    <img
      {...restProps}
      className="zoom-pan-image scope-064a2ddc"
      ref={imgRef}
      src={src}
      alt={alt}
      draggable="false"
      style={imgStyle}
      onLoad={handleLoad}
    />
  );
}

export default ZoomImage;
